import React, { useState } from "react";

const BRAND_RED = "#E31E24";
const BRAND_NAVY = "#2B2B6B";

// ── Tus imágenes desde public/images/ ───────────────────────────────
const img1 = "/images/TallerHuerto.png";
const img2 = "/images/Taller Bicentenario.jpeg";
const img3 = "/images/Limpieza4.jpeg";
const img4 = "/images/Session1-2.jpeg";
const img5 = "/images/Librosniños.jpeg";
const img6 = "/images/Spelling Bee.jpg";
const img7 = "/images/Sesion2d.jpeg";

// ── Your activity data ───────────────────────────────────────────────
const activities = [
  {
    id: 1,
    title: "Home vegetable garden.",
    date: "Fall, 2025",
    description:
      "Our students participated in a workshop on creating home gardens and caring for the environment. Over the course of four workshops, they learned to identify the most suitable and easy-to-grow seeds for a successful harvest, make natural repellents, correctly sort waste, compost, and adopt sustainable habits in their daily lives.",
    image: img1,
    side: "right",
  },
  {
    id: 2,
    title: "Parque Bicentenario",
    date: "February, 2026",
    description:
      "The students participated in activities designed to put their soft skills into practice in a dynamic and collaborative environment. Through various challenges, they strengthened competencies such as teamwork, communication, and problem-solving.",
    image: img2,
    side: "left",
  },
  {
    id: 3,
    title: "Earth day",
    date: "April 22, 2026",
    description:
      "Students from American College participated in a cleanup day at Cristo Redentor Parish. This activity was carried out in collaboration with the Social Action department and the parish's children's center, with the aim of restoring and preparing a green space for the benefit of the community.",
    image: img3,
    side: "right",
  },
  {
    id: 4,
    title: "Latin Top Jobs",
    date: "Spring, 2026",
    description:
      "In partnership with Latin Top Jobs, the college promotes talks, interactive sessions, and activities designed to prepare our students for the workforce. Thanks to the expertise of this talent recruitment firm, we have established a valuable collaboration that strengthens students' professional skills and aligns them with the demands of today's job market.",
    image: img4,
    side: "left",
  },
  {
    id: 5,
    title: "English workshops",
    date: "Spring, 2026",
    description:
      "As part of their community service program, American College students conduct English workshops for children and young people in the communities served by Acción Social de Cristo Redentor. Additionally, each participant receives a supplementary book that allows them to reinforce what they learned in class and continue practicing at home.",
    image: img5,
    side: "right",
  },
  {
    id: 6,
    title: "Spelling Bee",
    date: "September, 2026",
    description:
      "Students from American College volunteered at the Spelling Bee organized by Glasswing International, serving as judges during the competition for children from the República de Canadá Educational Center. This experience allowed them to strengthen their leadership, responsibility, and service skills, while also contributing to the development of an educational environment that fosters English language learning and collaborative work.",
    image: img6,
    side: "left",
  },
  {
    id: 7,
    title: "Wellness workshop",
    date: "September, 2026",
    description:
      "As part of our commitment to student well-being, the college held a wellness workshop for our students. This activity provided practical tools to strengthen emotional balance and promote healthy habits in their academic lives.",
    image: img7,
    side: "right",
  },
];

// ── Partner / alliance logos ──────────────────────────────────────────
// Replace `logo: null` with `logo: "/images/your-logo.png"` once you have
// the actual logo files, and the <img> will be used automatically instead
// of the text mark.
const partners = [
  { id: "p1", name: "Latin Top Jobs Group", logo: "/images/latinTop.png" },
  {
    id: "p2",
    name: "FUSAI · Fundación de Apoyo Integral",
    logo: "/images/fusai.png",
  },
  {
    id: "p3",
    name: "Alcaldía de San Salvador Centro",
    logo: "/images/alcaldia.png",
  },
  {
    id: "p4",
    name: "Ministerio de Acción Social",
    logo: "/images/ministerio.png",
  },
  { id: "p5", name: "Fusate", logo: "/images/fusate.png" },
  { id: "p6", name: "Paliamed", logo: "/images/Paliamed.png" },
  { id: "p7", name: "Contextos", logo: "/images/contextos.png" },
  { id: "p8", name: "Glasswing International", logo: "/images/glass.png" },
];

function TimelineItem({ title, date, description, image, side, isLast }) {
  const isRight = side === "right";
  const card = (align) => (
    <TimelineCard
      title={title}
      date={date}
      description={description}
      image={image}
      align={align}
    />
  );

  return (
    <div
      className="outreach-timeline-item"
      style={{
        display: "grid",
        gridTemplateColumns: "1fr 48px 1fr",
        gap: 0,
      }}
    >
      {/* Left column (solo escritorio) */}
      <div
        className="outreach-left-col"
        style={{
          padding: "0 2rem 3rem 0",
          display: "flex",
          justifyContent: "flex-end",
        }}
      >
        {!isRight && card("right")}
      </div>

      {/* Center spine */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <div
          style={{
            width: 16,
            height: 16,
            borderRadius: "50%",
            background: BRAND_RED,
            border: `3px solid #fff`,
            boxShadow: `0 0 0 2px ${BRAND_RED}`,
            flexShrink: 0,
            marginTop: 24,
            zIndex: 1,
          }}
        />
        {!isLast && (
          <div
            style={{
              width: 2,
              flex: 1,
              background: `linear-gradient(to bottom, ${BRAND_RED}40, ${BRAND_NAVY}20)`,
              marginTop: 4,
            }}
          />
        )}
      </div>

      <div
        className={`outreach-right-col ${isRight ? "" : "outreach-right-col--left-item"}`}
        style={{
          padding: "0 0 3rem 2rem",
          display: "flex",
          justifyContent: "flex-start",
        }}
      >
        {card("left")}
      </div>
    </div>
  );
}

function TimelineCard({ title, date, description, image, align }) {
  const [hovered, setHovered] = useState(false);

  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        background: "#ffffff",
        border: `0.5px solid ${hovered ? BRAND_NAVY + "40" : "#e0e0e0"}`,
        borderRadius: 14,
        overflow: "hidden",
        maxWidth: 420,
        width: "100%",
        boxShadow: hovered
          ? "0 8px 32px rgba(43,43,107,0.12)"
          : "0 2px 8px rgba(0,0,0,0.04)",
        transition:
          "box-shadow 0.25s ease, border-color 0.25s ease, transform 0.25s ease",
        transform: hovered ? "translateY(-3px)" : "translateY(0)",
      }}
    >
      {/* Image */}
      <div
        style={{
          width: "100%",
          height: 200,
          overflow: "hidden",
          position: "relative",
        }}
      >
        <img
          src={image}
          alt={title}
          style={{
            width: "100%",
            height: "200px",
            objectFit: "cover",
            transition: "transform 0.4s ease",
            transform: hovered ? "scale(1.04)" : "scale(1)",
          }}
        />
        <span
          style={{
            position: "absolute",
            top: 12,
            left: align === "left" ? 12 : "auto",
            right: align === "right" ? 12 : "auto",
            background: BRAND_NAVY,
            color: "#ffffff",
            fontSize: 11,
            fontWeight: 500,
            padding: "4px 10px",
            borderRadius: 100,
            letterSpacing: "0.03em",
          }}
        >
          {date}
        </span>
      </div>

      {/* Content */}
      <div style={{ padding: "1.1rem 1.25rem 1.25rem" }}>
        <div
          style={{
            width: 28,
            height: 3,
            background: BRAND_RED,
            borderRadius: 2,
            marginBottom: 10,
          }}
        />
        <h3
          style={{
            fontFamily: "'Playfair Display', serif",
            fontSize: 18,
            fontWeight: 700,
            color: BRAND_NAVY,
            margin: "0 0 8px",
            lineHeight: 1.25,
          }}
        >
          {title}
        </h3>
        <p
          style={{
            fontSize: 13,
            color: "#6b6b6b",
            lineHeight: 1.6,
            margin: 0,
          }}
        >
          {description}
        </p>
      </div>
    </div>
  );
}

// ── Animated "train" carousel of alliance logos ────────────────────────
function PartnersCarousel({ items }) {
  // Duplicate the list so the strip can loop seamlessly (0% -> -50%)
  const track = [...items, ...items];

  return (
    <div style={{ marginTop: "1rem" }}>
      <div style={{ textAlign: "center", marginBottom: "1.75rem" }}>
        <span
          style={{
            display: "block",
            fontSize: 12,
            fontWeight: 500,
            letterSpacing: "0.15em",
            textTransform: "uppercase",
            color: BRAND_RED,
            marginBottom: 8,
          }}
        >
          Our Alliances
        </span>
        <h3
          style={{
            fontFamily: "'Playfair Display', serif",
            fontSize: 26,
            fontWeight: 700,
            color: BRAND_NAVY,
            margin: 0,
          }}
        >
          Partners who make it possible
        </h3>
      </div>

      <div className="outreach-carousel-viewport">
        <div className="outreach-carousel-fade outreach-carousel-fade--left" />
        <div className="outreach-carousel-fade outreach-carousel-fade--right" />

        <div className="outreach-carousel-track">
          {track.map((p, i) => (
            <div className="outreach-carousel-card" key={`${p.id}-${i}`}>
              {p.logo ? (
                <div className="outreach-carousel-logo-frame">
                  <img src={p.logo} alt={p.name} />
                </div>
              ) : (
                <span className="outreach-carousel-mark">{p.name}</span>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default function SocialOutreachSection() {
  return (
    <section
      style={{
        fontFamily: "'DM Sans', 'Segoe UI', sans-serif",
        padding: "4rem 2rem 3rem",
        maxWidth: 1100,
        margin: "0 auto",
      }}
    >
      {/* Google Fonts */}
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700&family=DM+Sans:wght@400;500&display=swap');

        @media (max-width: 720px) {
          .outreach-timeline-item {
            grid-template-columns: 24px 1fr !important;
          }
          .outreach-left-col { display: none !important; }
          .outreach-right-col {
            padding-left: 1.25rem !important;
            padding-right: 0 !important;
            justify-content: flex-start !important;
          }
          .outreach-show-mobile { display: flex !important; }
        }

        /* ── Partners carousel ("train") ───────────────────────────── */
        .outreach-carousel-viewport {
          position: relative;
          width: 100%;
          overflow: hidden;
          padding: 0.5rem 0;
        }

        .outreach-carousel-track {
          display: flex;
          align-items: stretch;
          gap: 1.5rem;
          width: max-content;
          animation: outreach-train-scroll 28s linear infinite;
        }

        .outreach-carousel-viewport:hover .outreach-carousel-track {
          animation-play-state: paused;
        }

        .outreach-carousel-card {
          flex: 0 0 auto;
          width: 220px;
          height: 110px;
          background: #ffffff;
          border: 0.5px solid #e0e0e0;
          border-radius: 12px;
          box-shadow: 0 2px 8px rgba(0,0,0,0.04);
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 1.1rem 1.5rem;
          transition: box-shadow 0.25s ease, border-color 0.25s ease, transform 0.25s ease;
        }

        /* Fixed "canvas" so every logo — regardless of its own aspect
           ratio or built-in padding — reads at the same visual scale. */
        .outreach-carousel-logo-frame {
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .outreach-carousel-logo-frame img {
          max-width: 100%;
          max-height: 100%;
          width: auto;
          height: auto;
          object-fit: contain;
          filter: grayscale(100%);
          opacity: 0.65;
          transition: filter 0.3s ease, opacity 0.3s ease;
        }

        .outreach-carousel-card:hover .outreach-carousel-logo-frame img {
          filter: grayscale(0%);
          opacity: 1;
        }

        .outreach-carousel-card:hover {
          box-shadow: 0 8px 24px rgba(43,43,107,0.12);
          border-color: ${BRAND_NAVY}40;
          transform: translateY(-3px);
        }

        .outreach-carousel-mark {
          font-family: 'Playfair Display', serif;
          font-weight: 700;
          font-size: 15px;
          line-height: 1.3;
          text-align: center;
          color: ${BRAND_NAVY};
          letter-spacing: 0.01em;
        }

        .outreach-carousel-fade {
          position: absolute;
          top: 0;
          bottom: 0;
          width: 64px;
          z-index: 2;
          pointer-events: none;
        }
        .outreach-carousel-fade--left {
          left: 0;
          background: linear-gradient(to right, #ffffff, transparent);
        }
        .outreach-carousel-fade--right {
          right: 0;
          background: linear-gradient(to left, #ffffff, transparent);
        }

        @keyframes outreach-train-scroll {
          from { transform: translateX(0); }
          to { transform: translateX(-50%); }
        }

        @media (prefers-reduced-motion: reduce) {
          .outreach-carousel-track {
            animation: none;
          }
        }
          
      .outreach-right-col--left-item { display: none !important; }

      @media (max-width: 720px) {
      .outreach-timeline-item {
       grid-template-columns: 24px 1fr !important;
      }
      .outreach-left-col { display: none !important; }
      .outreach-right-col,
      .outreach-right-col--left-item {
       display: flex !important;   /* en móvil se muestran todas */
      padding-left: 1.25rem !important;
      padding-right: 0 !important;
      justify-content: flex-start !important;
     }
    }
      `}</style>

      {/* Header */}
      <div style={{ marginBottom: "4rem" }}>
        <span
          style={{
            display: "block",
            fontSize: 12,
            fontWeight: 500,
            letterSpacing: "0.15em",
            textTransform: "uppercase",
            color: BRAND_RED,
            marginBottom: 8,
          }}
        >
          Social Outreach
        </span>
        <h2
          style={{
            fontFamily: "'Playfair Display', serif",
            fontSize: 36,
            fontWeight: 700,
            color: BRAND_NAVY,
            margin: "0 0 12px",
            lineHeight: 1.15,
          }}
        >
          Making a difference,
          <br />
          one community at a time.
        </h2>
        <p
          style={{
            fontSize: 15,
            color: "#6b6b6b",
            maxWidth: 500,
            lineHeight: 1.6,
            margin: 0,
          }}
        >
          Beyond the classroom, our institution is committed to uplifting the
          communities around us through meaningful, sustained social action.
        </p>
      </div>

      {/* Timeline */}
      <div>
        {activities.map((activity, index) => (
          <TimelineItem
            key={activity.id}
            {...activity}
            isLast={index === activities.length - 1}
          />
        ))}
      </div>

      {/* Partners carousel */}
      <PartnersCarousel items={partners} />
    </section>
  );
}
